import { memo } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { KEYWORDS_LOADER_HEIGHT, KEYWORDS_LOADER_WIDTH } from "app/pages/activation/components/Topics/constants";
import { StyledTopicKeywords } from "app/pages/activation/components/Topics/Topic/styles";
import { KEYWORDS_LABEL } from "app/pages/activation/components/Topics/Topic/texts";

import { topicKWKeys } from "../automationKeys";

type TopicKeywordsSchema = {
    keywordsCount: number | string;
    isLoading: boolean;
};

export const TopicKeywords = memo(({ keywordsCount, isLoading }: TopicKeywordsSchema) =>
    isLoading ? (
        <span data-automation={topicKWKeys.preLoader}>
            <PixelPlaceholderLoader
                height={KEYWORDS_LOADER_HEIGHT}
                width={KEYWORDS_LOADER_WIDTH}
            />
        </span>
    ) : (
        <StyledTopicKeywords
            data-automation={topicKWKeys.keywords}
        >{`${keywordsCount} ${translate(KEYWORDS_LABEL)}`}</StyledTopicKeywords>
    ),
);

TopicKeywords.displayName = "TopicKeywords";
